import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { NodeWithI18n, TextAst } from '@angular/compiler';
import { noUndefined } from '@angular/compiler/src/util';



@Component({
  selector: 'app-student-setting',
  templateUrl: './student-setting.component.html',
  styleUrls: ['./student-setting.component.scss']
})
export class StudentSettingComponent implements OnInit, AfterViewInit {
  panelOpenState = false;
  Arr= [
    {name: 'Fax', display: '', Require: true, Visible: true},
    {name: 'Address', display: '', Require: false, Visible: true},
    {name: 'Email', display: '', Require: true, Visible: true},
    
  ];
  PersonalDetail : FormArray;
  PersonalDetailTable : []
  ContactDetail: FormArray;
  ContactDetailTable : []
  RegisterDetail : FormArray;
  QualificationDetail : FormArray;
  AdditionalDetail : FormArray;
  PhotoSign : FormArray;
  AdmissionDetail : FormArray;
  Document : FormArray;


  StudentEdit: FormGroup;
  
  ss: any[];
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder, 
    public router: Router,
    private dialog: MatDialog,
    ) {
      // this.dataSource2.data = TREE_DATA;  
    }
    // hasChild = (_: number, node: FoodNode) => !!node.Arr && node.Arr.length >= 0;
  
  arr1:any = [];
  aar: any = [];
  StudentArr: any = [];
  adminArr: any = [];
  ngOnInit(): void {
    let id = '';
    // this.check = false;
    this.StudentEdit = this.fb.group({
      FormName: new FormControl (''),
      FormRequired: new FormControl (''),
      FormVisible: new FormControl (''),
      FormDisplayName: new FormControl (''),
      FormPattern: new FormControl (''),
      FormControlName: new FormControl (''),
      FormType: new FormControl(''),
      FormPage: new FormControl(''),
      IsDefault: new FormControl(''),
        PersonalDetail: new FormArray([]),
        ContactDetail: new FormArray([]),
        RegisterDetail: new FormArray([]),
        QualificationDetail : new FormArray([]),
        AdditionalDetail : new FormArray([]),
        PhotoSign : new FormArray([]),
        AdmissionDetail : new FormArray([]),
        Document : new FormArray([]),

    });
    
    // this.getData(id);
  }

  ngAfterViewInit(): void{
  }

  getPersonalDetailControls(){
    return (this.StudentEdit.get('PersonalDetail') as FormArray).controls;
  }
  getContactDetailControls(){
    return (this.StudentEdit.get('ContactDetail') as FormArray).controls;
  }
  getRegisterDetailControls(){
    return (this.StudentEdit.get('RegisterDetail') as FormArray).controls;
  }
  getQualificationDetailControls(){
    return (this.StudentEdit.get('QualificationDetail') as FormArray).controls;
  }
  getAdditionalDetailControls(){
    return (this.StudentEdit.get('AdditionalDetail') as FormArray).controls;
  }
  getPhotoSignControls(){
    return (this.StudentEdit.get('PhotoSign') as FormArray).controls;
  }
  getAdmissionDetailControls(){
    return (this.StudentEdit.get('AdmissionDetail') as FormArray).controls;
  }
  getDocumentControls(){
    return (this.StudentEdit.get('Document') as FormArray).controls;
  }
  
  getData(id){
    const payload = {};
    payload['FormPage'] = id;
      this.umsService.getStdSetting(payload).subscribe(res => {
      
        this.PersonalDetailTable = res.data
        this.PersonalDetailTable.map((element, i) => {;
          if(element['FormPage']=='PersonalDetails'){
            this.PersonalDetail = this.StudentEdit.get('PersonalDetail') as FormArray;
            this.PersonalDetail.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='ContactDetails'){
            this.ContactDetail = this.StudentEdit.get('ContactDetail') as FormArray;
            this.ContactDetail.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='ReserveDetails'){
            this.RegisterDetail = this.StudentEdit.get('RegisterDetail') as FormArray;
            this.RegisterDetail.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='QualifyDetails'){
            this.QualificationDetail = this.StudentEdit.get('QualificationDetail') as FormArray;
            this.QualificationDetail.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='AdditionalDetail'){
            this.AdditionalDetail = this.StudentEdit.get('AdditionalDetail') as FormArray;
            this.AdditionalDetail.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='PhotoSign'){
            this.PhotoSign = this.StudentEdit.get('PhotoSign') as FormArray;
            this.PhotoSign.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='AdmDetails'){
            this.AdmissionDetail = this.StudentEdit.get('AdmissionDetail') as FormArray;
            this.AdmissionDetail.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          else if(element['FormPage']=='Documents'){
            this.Document = this.StudentEdit.get('Document') as FormArray;
            this.Document.push(this.fb.group({
            FormName: new FormControl (element['FormName']),
            FormRequired: new FormControl (element['FormRequired']),
            FormVisible: new FormControl (element['FormVisible']),
            FormDisplayName: new FormControl (element['FormDisplayName']),
            FormPattern: new FormControl (element['FormPattern']),
            FormControlName: new FormControl (element['FormControlName']),
            FormType: new FormControl(element['FormType']),
            FormPage: new FormControl(element['FormPage']),
            IsDefault: new FormControl(element['IsDefault']),
            ID: new FormControl(element['ID']),
            }));
          }
          
        });
      });
   
  }


  redirect(to: string): void {
    this.router.navigate([to]);
  }

  next(){
    this.redirect('student-form');
  }
  Regnext(){
    this.redirect('student-registration-tab');
  }

  updateDetails(e){
    this.umsService.updateStdSetting(e.value).subscribe(res => {
      // this.ngOnInit();
      alert(res.message)
    });
  }

  // save(){
  //   this.update();
  // }

}
